import React from "react";
import { Col } from "antd";

export function Settings() {
  return <Col style={{ marginTop: "20px" }}>Settings</Col>;
}
